import * as firebase from "firebase";
import { install } from "ga-gtag";

let config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
firebase.initializeApp(config);

install(process.env.REACT_APP_GOOGLE_ANALYTICS);

// if (window.location.hostname.indexOf("localhost") >= 0) {
//   firebase.functions().useFunctionsEmulator("http://localhost:5000");
// }

export const firestore = firebase.firestore();
export const storageBucket = firebase.app().storage("gs://convert-excel");
export const storage = firebase.storage();
export default firebase;



// WEBPACK FOOTER //
// ./src/common/Firebase.ts